var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierBg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: "current"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M102.965 5.97188C104.896 3.11415 109.104 3.11416 111.035 5.97189L132.674 38.0022C133.767 39.619 135.719 40.4276 137.635 40.0567L175.585 32.7095C178.971 32.054 181.946 35.0294 181.291 38.4153L173.943 76.3657C173.573 78.2814 174.381 80.2334 175.998 81.3258L208.028 102.966C210.886 104.896 210.886 109.104 208.028 111.035L175.998 132.674C174.381 133.767 173.573 135.719 173.943 137.635L181.291 175.585C181.946 178.971 178.971 181.946 175.585 181.291L137.634 173.943C135.719 173.573 133.767 174.381 132.674 175.998L111.035 208.028C109.104 210.886 104.896 210.886 102.965 208.028L81.3258 175.998C80.2334 174.381 78.2813 173.573 76.3657 173.943L38.4152 181.291C35.0293 181.946 32.0539 178.971 32.7094 175.585L40.0567 137.635C40.4276 135.719 39.619 133.767 38.0021 132.674L5.97186 111.035C3.11413 109.104 3.11414 104.896 5.97187 102.965L38.0022 81.3258C39.619 80.2334 40.4276 78.2814 40.0567 76.3657L32.7095 38.4153C32.0539 35.0293 35.0293 32.0539 38.4153 32.7095L76.3657 40.0567C78.2814 40.4276 80.2334 39.619 81.3258 38.0022L102.965 5.97188Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.997 35.6807L137.805 77.1262L179.251 107.934L137.805 138.742L106.997 180.187L76.1897 138.742L34.7441 107.934L76.1897 77.1262L106.997 35.6807Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.245 63.098C107.866 61.8757 106.136 61.8758 105.757 63.098L96.494 92.9475L82.9964 125.927C82.4972 127.147 83.9172 128.251 84.9767 127.468L106.226 111.752C106.687 111.412 107.315 111.412 107.776 111.752L129.025 127.468C130.085 128.251 131.505 127.147 131.006 125.927L117.508 92.9475L108.245 63.098Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 130.237L107 145.178",
    stroke: "#E0E0E0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierBg3);
export default __webpack_public_path__ + "static/media/tier-bg-3.e4f72eb18283ab995bfaf2d8dc6c3e6d.svg";
export { ForwardRef as ReactComponent };